import { Link, useLoaderData } from "react-router-dom";
import { useAuth } from "../../hooks/useAuth";
import { PodcastCard } from "../../components/podcasts/PodcastCard";
import { LinkButton } from "../../components/common";
import type { PodcastListData } from "../../routes/loaders";
import type { Role } from "../../types/user";
import styles from "./PodcastListPage.module.css";

export default function PodcastListPage() {
  const { podcasts, organizationId } = useLoaderData() as PodcastListData;
  const { user } = useAuth();

  const userRole: Role | undefined = user?.organizations.find(
    (org) => org.id === organizationId,
  )?.role;

  const canCreatePodcast = userRole === "owner" || userRole === "admin";

  return (
    <div className="container">
      <div className={styles.pageHeader}>
        <div>
          <h1>Podcasts</h1>
          <Link to={`/organizations/${organizationId}`} className={styles.backLink}>
            Back to Organization
          </Link>
        </div>
        {canCreatePodcast && (
          <div style={{ display: "flex", gap: "var(--spacing-3)" }}>
            <LinkButton to={`/organizations/${organizationId}/podcasts/import`} variant="secondary">
              Import Podcast
            </LinkButton>
            <LinkButton to={`/organizations/${organizationId}/podcasts/create`} variant="primary">
              Create Podcast
            </LinkButton>
          </div>
        )}
      </div>

      {podcasts.length === 0 ? (
        <div className={styles.emptyState}>
          <div className={styles.emptyIcon}>
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z" />
              <path d="M19 10v2a7 7 0 0 1-14 0v-2" />
              <line x1="12" y1="19" x2="12" y2="23" />
              <line x1="8" y1="23" x2="16" y2="23" />
            </svg>
          </div>
          <h2>No podcasts yet</h2>
          <p>Create your first podcast to start publishing episodes.</p>
          {canCreatePodcast && (
            <LinkButton to={`/organizations/${organizationId}/podcasts/create`} variant="primary">
              Create Your First Podcast
            </LinkButton>
          )}
        </div>
      ) : (
        <div className={styles.podcastGrid}>
          {podcasts.map((podcast) => (
            <PodcastCard key={podcast.id} podcast={podcast} organizationId={organizationId} />
          ))}
        </div>
      )}
    </div>
  );
}
